import { Card, Center, Container, Group, Loader, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import { IconSettings } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import { useAppsList } from '../../queries/apps';
import { useAuthStore } from '../../auth/auth-store';
import { useProjectStore } from '../../project/project-store';
import type { AppSummary } from '../../types/api';
import { appKeyToSlug } from '../../app-shell/app-slug';

function AppCard({ app }: { app: AppSummary }) {
  return (
    <Card
      component={Link}
      to={`/a/${appKeyToSlug(app.key)}`}
      onClick={() => useProjectStore.getState().setApp(app.key)}
      withBorder
      padding="lg"
    >
      <Stack gap={4}>
        <Title order={4}>{app.name}</Title>
        <Text size="sm" c="dimmed">
          Open &rarr;
        </Text>
      </Stack>
    </Card>
  );
}

export function HomePage() {
  const { data: apps, isLoading } = useAppsList();
  const systemRole = useAuthStore((s) => s.user?.system_role);

  if (isLoading) {
    return (
      <Center h="60vh">
        <Loader />
      </Center>
    );
  }

  return (
    <Container size="lg">
      <Stack gap="xl">
        <Stack gap={4}>
          <Title order={1}>Welcome</Title>
          <Text c="dimmed">Choose an app to continue.</Text>
        </Stack>

        <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="md">
          {(apps ?? []).map((app) => (
            <AppCard key={app.key} app={app} />
          ))}

          {systemRole === 'superadmin' && (
            <Card component={Link} to="/admin" withBorder padding="lg">
              <Stack gap={4}>
                <Group gap="sm">
                  <IconSettings size={20} />
                  <Title order={4}>Admin</Title>
                </Group>
                <Text size="sm" c="dimmed">
                  Manage users, projects, companies, and global settings.
                </Text>
              </Stack>
            </Card>
          )}
        </SimpleGrid>
      </Stack>
    </Container>
  );
}
